export default __webpack_public_path__ + "static/media/topsrc.d562df38.svg";